import { IToastConfig } from 'src/common/primitives/Toast';

export function generateDeleteSuccessToast(id: number): IToastConfig {
  return {
    id,
    title: `The passenger has been deleted`,
  };
}
